const LayoutEmpty = () => import('@/components/layout/Empty.vue')

export default {
  path: '/',
  component: LayoutEmpty,
  children: [
    {
      name: 'index',
      path: '',
      meta: { needLogin: false },
      component: () => import(/* webpackChunkName: "index" */ '@/views/index/index.vue')
    },
    {
      name: 'pingban',
      path: 'pingban',
      meta: { needLogin: false },
      component: () => import(/* webpackChunkName: "iframe" */ '@/views/iframe/index.vue')
    },
    {
      name: 'shouji',
      path: 'shouji',
      meta: { needLogin: false },
      component: () => import(/* webpackChunkName: "iframe" */ '@/views/iframe/index.vue')
    }
  ]
}
